import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Router } from '@angular/router';
import { CMSService } from '../Services/cms.service';
import { CmsAboutUsLandingProperties } from '../Models/CmsAboutUsProperties';
import { CmsAboutUsServicesProperties } from '../Models/CmsAboutUsProperties';
import { CmsAboutUsTimelineProperties } from '../Models/CmsAboutUsProperties';
import { CmsContactUsFormProperties, CmsContactUsProperties } from '../Models/CmsContactUsProperties';
import { CmsFooterContactsProperties, CmsFooterSitemapProperties, CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLoginHeaderProperties, CmsLogoProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { CmsLoginDealsProperties } from '../Models/CmsLoginDealsProperties';

@Component({
    selector: 'app-about-us-sub',
    templateUrl: './about-us-sub.component.html',
    styleUrls: ['./about-us-sub.component.css']
})
/** AboutUsSub component*/
export class AboutUsSubComponent {
    /** AboutUsSub ctor */
  constructor(private cmsService: CMSService, private userService: CMSService, private router: Router) { }
  contactUs: CmsContactUsProperties[] = [];

  contactUsForm = new CmsContactUsFormProperties();
  footerContacts: CmsFooterContactsProperties[] = [];
  allData$: GetAllCmsLoginProperties;
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];

  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  homeLogo = new CmsLogoProperties();

  landingData: CmsAboutUsLandingProperties[] = [];
  servicesData: CmsAboutUsServicesProperties[] = [];
  timelineData: CmsAboutUsTimelineProperties[] = [];
  logo = '';
  ngOnInit() {
    this.getLandingData();
    this.getServicesData();
    //this.getTimelineData();
    //this.getAllData();
  }
  getAllData() {
    try {
      this.cmsService.getAllLoginPageData().subscribe((data) => {
        this.allData$ = data;
        this.navigation = data.navigation;
        //console.log (this.navigation);
        this.loginLanding = this.allData$.loginLanding;
        this.deals = this.allData$.deals;
        this.footerContacts = this.allData$.footerContacts;
        this.footerSitemap = this.allData$.footerSitemap;
        this.footerSocial = this.allData$.footerSocial;
        this.homeLogo = this.allData$.logo[0];
        this.logo = this.homeLogo.logo;
        //this.filtersLoaded = Promise.resolve(true);
      });
    } catch (e) { }
  }
  getLandingData() {
    try {
      this.userService.getAboutUsLanding().subscribe((data) => { this.landingData = data; });
    }
    catch (e) { ////console.log (e);
    }
  }
  getServicesData() {
    try {
      this.userService.getAboutUsServices().subscribe((data) => { this.servicesData = data; });
    }
    catch (e) { ////console.log (e);
    }
  }
  getTimelineData() {
    try {
      this.userService.getAboutUsTimeline().subscribe((data) => { this.timelineData = data; });
    }
    catch (e) { ////console.log (e);
    }
  }

}
